import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import { getToken, login } from "@/utils";

Vue.use(Router)

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
};

const router = new Router({
  mode: "history",
  base: '/review/',
  routes: [
    {
      path: '/',
      name: 'layout',
      redirect: '/ability-compet/activity/list',
      component: () => import('@/components/layout'),
      children: [
        //能力大赛
        {
          path: 'ability-compet',
          redirect: '/ability-compet/admin/activityMsg',
          component: () => import('@/pages/ability-compet'),
          children: [
            //admin后台路由
            {
              path: 'admin/activityMsg',
              component: () => import('@/pages/ability-compet/admin/activityMsg'),
              children: [
                {
                  path: '',
                  name: 'activityMsg',
                  meta: {
                    auth: true,
                    title: "活动管理",
                    breadcrumb: [
                      {path: '', label: '活动管理'},
                      {path: '', label: '活动列表'}
                    ]
                  },
                  component: () => import('@/pages/ability-compet/admin/activityMsg/list')
                },
                {
                  path: 'add',
                  name: 'activity-add',
                  meta: {
                    auth: true,
                    title: "活动管理",
                    breadcrumb: [
                      {path: '', label: '活动管理'},
                      {path: '', label: '活动列表'},
                      {path: '', label: '新增活动'}
                    ]
                  },
                  component: () => import('@/pages/ability-compet/admin/activityMsg/add')
                }
              ]
            },
            {
              path: 'admin/activityInfo',
              component: () => import('@/pages/ability-compet/admin/activityInfo'),
              children: [
                {
                  path: 'recommended-unit',
                  name: 'recommended-unit',
                  meta: {
                    auth: true,
                    title: "推荐单位管理",
                    breadcrumb: [
                      {path: '', label: '活动管理'},
                      {path: '', label: '活动列表'}
                    ]
                  },
                  component: () => import('@/pages/common/recommended-unit')
                },
                {
                  path: 'player',
                  name: 'player',
                  meta: {
                    auth: true,
                    title: "选手管理",
                    breadcrumb: [
                      {path: '', label: '活动管理'},
                      {path: '', label: '活动列表'}
                    ]
                  },
                  component: () => import('@/pages/ability-compet/admin/activityInfo/player')
                },
                {
                  path: 'resource',
                  name: 'resource',
                  meta: {
                    auth: true,
                    title: "资源管理",
                    breadcrumb: [
                      {path: '', label: '活动管理'},
                      {path: '', label: '活动列表'}
                    ]
                  },
                  component: () => import('@/pages/ability-compet/admin/activityInfo/resource')
                },
                {
                  path: 'expert',
                  name: 'expert',
                  meta: {
                    auth: true,
                    title: "专家管理",
                    breadcrumb: [
                      {path: '', label: '活动管理'},
                      {path: '', label: '活动列表'}
                    ]
                  },
                  component: () => import('@/pages/ability-compet/admin/activityInfo/expert')
                },
                {
                  path: 'group',
                  name: 'group',
                  meta: {
                    auth: true,
                    title: "组别管理",
                    breadcrumb: [
                      {path: '', label: '活动管理'},
                      {path: '', label: '活动列表'}
                    ]
                  },
                  component: () => import('@/pages/common/group')
                },
                {
                  path: 'reviewMsg',
                  name: 'reviewMsg',
                  meta: {
                    auth: true,
                    title: "评审组",
                    breadcrumb: [
                      {path: '', label: '活动管理'},
                      {path: '', label: '活动列表'}
                    ]
                  },
                  component: () => import('@/pages/ability-compet/admin/activityInfo/reviewMsg')
                },
                {
                  path: 'review-deploy',
                  name: 'reviewDeploy',
                  meta: {
                    auth: true,
                    title: "评审配置",
                    breadcrumb: [
                      {path: '', label: '活动管理'},
                      {path: '', label: '活动列表'}
                    ]
                  },
                  component: () => import('@/pages/common/review-deploy')
                },
                {
                  path: 'expert-progress',
                  name: 'expertProgress',
                  meta: {
                    auth: true,
                    title: "专家进度监控",
                    breadcrumb: [
                      {path: '', label: '活动管理'},
                      {path: '', label: '活动列表'}
                    ]
                  },
                  component: () => import('@/pages/ability-compet/admin/activityInfo/expert-progress')
                },
                {
                  path: 'review-results',
                  name: 'reviewResults',
                  meta: {
                    auth: true,
                    title: "评审结果汇总",
                    breadcrumb: [
                      {path: '', label: '活动管理'},
                      {path: '', label: '活动列表'}
                    ]
                  },
                  component: () => import('@/pages/ability-compet/admin/activityInfo/review-results')
                }
              ]
            },
            {
              path: 'admin/player/detail',
              component: () => import('@/pages/ability-compet/admin/detail/player'),
              children: [
                {
                  path: '',
                  name: 'admin-player-detail',
                  meta: {
                    auth: true,
                    title: "基本信息"
                  },
                  component: () => import('@/pages/ability-compet/room/player/detail/info')
                },
                {
                  path: 'resource',
                  name: 'player-detail-resource',
                  meta: {
                    auth: true,
                    title: "资源附件"
                  },
                  component: () => import('@/pages/common/resource')
                },
                {
                  path: 'enclosure',
                  name: 'player-detail-enclosure',
                  meta: {
                    auth: true,
                    title: "资源附件"
                  },
                  component: () => import('@/pages/common/resource')
                }
              ]
            },
            {
              path: 'admin/expert/detail',
              component: () => import('@/pages/ability-compet/admin/detail/expert'),
              children: [
                {
                  path: '',
                  name: 'admin-expert-detail',
                  meta: {
                    auth: true,
                    title: "基本信息"
                  },
                  component: () => import('@/pages/ability-compet/room/expert/detail/info')
                },
                {
                  path: 'resource',
                  name: 'expert-detail-resource',
                  meta: {
                    auth: true,
                    title: "资源附件"
                  },
                  component: () => import('@/pages/common/resource')
                }
              ]
            },
            {
              path: 'admin/expertLibrary',
              component: () => import('@/pages/ability-compet/admin/expertLibrary'),
              redirect: {name: 'expertLibraryList'},
              meta: {
                auth: true,
                title: "专家库",
              },
              children: [
                {
                  path: 'list',
                  name: 'expertLibraryList',
                  meta: {
                    auth: true,
                    title: "专家库",
                    breadcrumb: [
                      {path: '', label: '专家库'},
                      {path: '', label: '专家管理'}
                    ]
                  },
                  component: () => import('@/pages/ability-compet/admin/expertLibrary/list')
                },
                {
                  path: 'recover',
                  name: 'expertLibraryListRecover',
                  meta: {
                    auth: true,
                    title: "专家库",
                    breadcrumb: [
                      {path: '', label: '专家库'},
                      {path: '', label: '回收站'}
                    ]
                  },
                  component: () => import('@/pages/ability-compet/admin/expertLibrary/recover')
                }
              ]
            },
            //room空间路由
            {
              path: 'room/company',
              name: 'company',
              meta: {
                auth: true,
                title: "推荐单位",
                breadcrumb: [
                  {path: '', label: '活动管理'},
                  {path: '', label: '活动列表'}
                ]
              },
              component: () => import('@/pages/ability-compet/room/company')
            },
            {
              path: 'room/company/info',
              name: 'company-info',
              meta: {
                auth: true,
                title: "单位信息维护",
                breadcrumb: [
                  {path: '', label: '活动管理'},
                  {path: '', label: '单位信息维护'}
                ]
              },
              component: () => import('@/pages/ability-compet/room/company/info')
            },
            {
              path: 'room/company/player',
              name: 'company-player',
              meta: {
                auth: true,
                title: "推荐选手",
                breadcrumb: [
                  {path: '', label: '首页'},
                  {path: '', label: '推荐选手'}
                ]
              },
              component: () => import('@/pages/ability-compet/room/company/player/list')
            },
            {
              path: 'room/player/index',
              name: 'player-index',
              meta: {
                auth: true,
                title: "信息填报",
              },
              component: () => import('@/pages/ability-compet/room/player')
            },
            {
              path: 'room/company/player/detail',
              component: () => import('@/pages/ability-compet/room/player/detail'),
              children: [
                {
                  path: '',
                  name: 'room-company-player-detail',
                  meta: {
                    auth: true,
                    title: "基本信息"
                  },
                  component: () => import('@/pages/ability-compet/room/player/detail/info')
                },
                {
                  path: 'resource',
                  name: 'player-company-detail-resource',
                  meta: {
                    auth: true,
                    title: "资源附件"
                  },
                  component: () => import('@/pages/common/resource')
                },
                {
                  path: 'enclosure',
                  name: 'player-company-detail-enclosure',
                  meta: {
                    auth: true,
                    title: "资源附件"
                  },
                  component: () => import('@/pages/common/resource')
                }
              ]
            },

            {
              path: 'room/company/expert/detail',
              component: () => import('@/pages/ability-compet/room/expert/detail'),
              children: [
                {
                  path: '',
                  name: 'room-company-expert-detail',
                  meta: {
                    auth: true,
                    title: "基本信息"
                  },
                  component: () => import('@/pages/ability-compet/room/expert/detail/info')
                },
                {
                  path: 'resource',
                  name: 'expert-company-detail-resource',
                  meta: {
                    auth: true,
                    title: "资源附件"
                  },
                  component: () => import('@/pages/common/resource')
                }
              ]
            },
            {
              path: 'room/company/upload',
              name: 'company-upload',
              meta: {
                auth: true,
                title: "附件上传",
                breadcrumb: [
                  {path: '', label: '首页'},
                  {path: '', label: '附件上传'}
                ]
              },
              component: () => import('@/pages/ability-compet/room/company/upload')
            },
            {
              path: 'room/player/detail',
              component: () => import('@/pages/ability-compet/room/player/detail'),
              children: [
                {
                  path: '',
                  name: 'room-player-detail',
                  meta: {
                    auth: true,
                    title: "基本信息"
                  },
                  component: () => import('@/pages/ability-compet/room/player/detail/info')
                },
                {
                  path: 'resource',
                  name: 'player-detail-resource',
                  meta: {
                    auth: true,
                    title: "资源附件"
                  },
                  component: () => import('@/pages/common/resource')
                },
                {
                  path: 'enclosure',
                  name: 'player-detail-enclosure',
                  meta: {
                    auth: true,
                    title: "资源附件"
                  },
                  component: () => import('@/pages/common/resource')
                }
              ]
            },
            {
              path: 'room/expert/detail',
              component: () => import('@/pages/ability-compet/room/expert/detail'),
              children: [
                {
                  path: '',
                  name: 'room-expert-detail',
                  meta: {
                    auth: true,
                    title: "基本信息"
                  },
                  component: () => import('@/pages/ability-compet/room/expert/detail/info')
                },
                {
                  path: 'resource',
                  name: 'expert-detail-resource',
                  meta: {
                    auth: true,
                    title: "资源附件"
                  },
                  component: () => import('@/pages/common/resource')
                }
              ]
            },

            {
              path: 'room/player/list',
              name: 'player-list',
              meta: {
                auth: true,
                title: "活动列表",
                breadcrumb: [
                  {path: '', label: '活动管理'},
                  {path: '', label: '活动列表'}
                ]
              },
              component: () => import('@/pages/ability-compet/room/player/list')
            },
            {
              path: 'room/expert/list',
              name: 'expert-list',
              meta: {
                auth: true,
                title: "活动列表",
                breadcrumb: [
                  {path: '', label: '活动管理'},
                  {path: '', label: '活动列表'}
                ]
              },
              component: () => import('@/pages/ability-compet/room/expert/list')
            },
            {
              path: 'room/expert/info',
              name: 'expert-info',
              meta: {
                auth: true,
                title: "专家信息完善",
                breadcrumb: [
                  {path: '', label: '活动管理'},
                  {path: '', label: '专家信息完善'}
                ]
              },
              component: () => import('@/pages/ability-compet/room/expert/info')
            },
            {
              path: 'room/expert/review-task',
              name: 'reviewTask',
              meta: {
                auth: true,
                title: "评审任务",
                breadcrumb: [
                  {path: '', label: '活动管理'},
                  {path: '', label: '活动列表'}
                ]
              },
              component: () => import('@/pages/ability-compet/room/expert/review-task/list')
            },
            {
              path: 'room/expert/review-task/detail',
              component: () => import('@/pages/ability-compet/room/expert/review-task/detail'),
              children: [
                {
                  path: '',
                  name: 'reviewTaskDetail',
                  meta: {
                    auth: true,
                    title: "评审页面"
                  },
                  component: () => import('@/pages/common/resource')
                }
              ]
            }

          ]
        },
        //公共路由
        {
          path: 'admin/systemMsg',
          component: () => import('@/pages/common/systemMsg'),
          children: [
            {
              path: 'import-log',
              name: 'importLog',
              meta: {
                auth: true,
                title: "导入日志",
                breadcrumb: [
                  {path: '', label: '系统管理'},
                  {path: '', label: '导入日志'}
                ]
              },
              component: () => import('@/pages/common/systemMsg/import-log')
            },
            {
              path: 'resource-type',
              name: 'resourceType',
              meta: {
                auth: true,
                title: "资源类型",
                breadcrumb: [
                  {path: '', label: '系统管理'},
                  {path: '', label: '资源类型'}
                ]
              },
              component: () => import('@/pages/common/systemMsg/resource-type')
            },
            {
              path: 'activity-manager',
              name: 'activityManager',
              meta: {
                auth: true,
                title: "活动管理员",
                breadcrumb: [
                  {path: '', label: '系统管理'},
                  {path: '', label: '活动管理员'}
                ]
              },
              component: () => import('@/pages/common/systemMsg/activity-manager')
            },
          ]
        }
      ]
    },
    //能力大赛room入口
    {
      path: '/ability-compet/activity/home',
      name: 'activity-home',
      meta: {
        auth: false,
        title: "活动详情"
      },
      component: () => import('@/pages/ability-compet/room')
    },
    {
      path: '/ability-compet/activity/list',
      name: 'activity-list',
      meta: {
        auth: false,
        title: "活动列表"
      },
      component: () => import('@/pages/ability-compet/activity')
    },
    {
      path: '/ability-compet/activity/room/updatePassword',
      name: 'updatePassword',
      meta: {
        auth: false,
        title: "修改密码"
      },
      component: () => import('@/pages/ability-compet/room/updatePassword')
    },
    {
      path: '/ability-compet/activity/no-auth',
      name: 'noAuth',
      meta: {
        auth: false,
        title: "没有权限"
      },
      component: () => import('@/pages/ability-compet/no-auth')
    },
  ]
})

//页面置顶
router.afterEach((to, from, next) => {
    window.scrollTo(0, 0)
})

//导航守卫
router.beforeEach((to, from, next) => {
    if (to.meta.title) {
        document.title = to.meta.title;
    }
    store.dispatch('CONFIG_SET').then(() => {
        if(!to.meta.auth && !!!to.query.code){
            next();
        }else{
            isLogin(to, next);
        }
    })
})

//登录拦截
async function isLogin(to, next) {

    const accessToken = getToken();
    if(accessToken && accessToken !== 'null' && accessToken !== 'undefined') {
        next();
    }else{
        if(to.query.code) {
            store.dispatch('login', { code: to.query.code }).then(() => {
                next();
            })
        }else{
            login()
        }
    }
}

export default router






// WEBPACK FOOTER //
// ./src/router/index.js